export const getters = {
  INVOICES: state => state.invoices,
  INVOICES_PAGINATION: state => state.invoices_pagination,
  COMPANIES: state => state.companies,
  COMPANIES_PAGINATION: state => state.companies_pagination,
  STATISTICS: state => state.statistics,
}
